import React, { useState } from 'react';
import Link from '@material-ui/core/Link';
import * as actions from 'Store/actions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useForm } from 'react-hook-form';
import FormTextField from 'Components/FormTextField';
import ModalContent from '../ModalContent';
import Alert from '@material-ui/lab/Alert';
import CheckIcon from '@material-ui/icons/Check';
import { withStyles } from '@material-ui/core';
import Collapse from '@material-ui/core/Collapse';
import * as Regex from '../../regex';

const styles = (theme) => ({
  successMessage: {
    marginTop: '20px',
  },
});

function ResetPassword({ passwordReset, setActiveModal, classes }) {
  const [wasPasswordRequestSent, setWasPasswordRequestSent] = useState(false);
  const [emailRequested, setEmailRequested] = useState();

  const { register, handleSubmit, errors, reset } = useForm({
    defaultValues: {},
  });

  const handleLoginModalOpen = () => {
    setActiveModal('login');
  };

  const onSubmit = async (data, event) => {
    const { email } = data;

    try {
      const passwordRes = await passwordReset({
        email,
      });

      setEmailRequested(email);
      reset();
    } catch (err) {
      console.warn('Reset server error: ', err);
      alert('Reset connection error');
      return;
    }

    setWasPasswordRequestSent(true);
  };

  const renderSuccessMessage = () => {
    return (
      <Collapse in={wasPasswordRequestSent}>
        <Alert
          icon={<CheckIcon fontSize="inherit" />}
          severity="success"
          onClose={() => setWasPasswordRequestSent(false)}
          className={classes.successMessage}
        >
          If there is an account associated with {emailRequested} you will
          receive reset instructions
        </Alert>
      </Collapse>
    );
  };

  return (
    <ModalContent
      title="Reset Password"
      buttonText="Reset Password"
      onFormSubmit={handleSubmit(onSubmit)}
      formContents={
        <>
          {renderSuccessMessage()}
          <FormTextField
            fullWidth
            label="Email"
            name="email"
            margin="normal"
            required
            error={!!errors.email}
            helperText={errors.email && errors.email.message}
            inputRef={register({
              required: 'Provide your login email',
              pattern: {
                value: Regex.email,
                message: 'Provide a valid email address',
              },
            })}
            placeholder="Enter Email"
          />
        </>
      }
      footerContents={
        <Link component="button" variant="body2" onClick={handleLoginModalOpen}>
          {'Login'}
        </Link>
      }
    />
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      passwordReset: actions.passwordReset,
      setActiveModal: actions.setActiveModal,
    },
    dispatch,
  );
}

export default withRouter(
  connect(null, mapDispatchToProps)(withStyles(styles)(ResetPassword)),
);
